import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class ReportCardService {
    async getList(params: any, page: string, size: string): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.SALES_ABANDONED_CARTS}?size=${size}&page=${page}`, params);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async getReportTotal(params: any): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.REPORT_CARD}`, params);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }
}

const reportCardService = new ReportCardService();
export default reportCardService;